<div class="app-tooltip">
  <img class="app-tooltip__icon" src="assets/icons/tooltip.svg" (mouseenter)="setHovered(true)" (mouseleave)="setHovered(false)" />

  <div *ngIf="hovered" class="app-tooltip__hover-container">
    <p class="app-tooltip__text">{{ text }}</p>
  </div>
</div>
